export interface IPagedRequest {
  kind: string;
  pageNumber: number;
  pageSize: number;
}

export class PagedRequest implements IPagedRequest {
  kind = 'PagedRequest' as const;
  pageNumber: number;
  pageSize: number;

  constructor(pageNumber = 1, pageSize = 20) {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
  }
}

export interface ISearchablePagedRequest extends IPagedRequest {
  searchText?: string;
}

export class SearchablePagedRequest implements ISearchablePagedRequest {
  kind = 'SearchablePagedRequest' as const;
  pageNumber: number;
  pageSize: number;
  searchText?: string;

  constructor(pageNumber = 1, pageSize = 20, searchText?: string) {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.searchText = searchText;
  }
}

export interface ISortablePagedRequest extends ISearchablePagedRequest {
  sortProperty?: string;
  sortDirection: 'ascending' | 'descending';
}

export class SortablePagedRequest implements ISortablePagedRequest {
  kind = 'SortablePagedRequest' as const;
  pageNumber: number;
  pageSize: number;
  searchText?: string;
  sortProperty?: string | undefined;
  sortDirection: 'ascending' | 'descending' = 'descending';

  constructor(pageNumber = 1, pageSize = 20, searchText?: string, sortProperty?: string, sortDirection: 'ascending' | 'descending' = 'descending') {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.searchText = searchText;
    this.sortProperty = sortProperty;
    this.sortDirection = sortDirection;
  }
}
